export default {
  // Header
  "co.header.badge": "Strategic Consulting",
  "co.header.back": "Back",
  "co.header.active": "Active Consulting",

  // Hero slides
  "co.hero.slide1.tag": "Strategic Consulting",
  "co.hero.slide1.title": "Digital Transformation",
  "co.hero.slide1.highlight": "with Security",
  "co.hero.slide1.subtitle": "Specialized advisory to strengthen your organization's security posture with proven methodologies and international frameworks such as ISO 27001, NIST and PCI DSS.",
  "co.hero.slide1.cta": "View services",

  "co.hero.slide2.tag": "Assessment & Diagnosis",
  "co.hero.slide2.title": "Comprehensive Security",
  "co.hero.slide2.highlight": "Assessment",
  "co.hero.slide2.subtitle": "We conduct thorough diagnostics of your infrastructure, processes and security controls to identify vulnerabilities and define prioritized roadmaps.",
  "co.hero.slide2.cta": "Learn more",

  "co.hero.slide3.tag": "Regulatory Compliance",
  "co.hero.slide3.title": "Governance &",
  "co.hero.slide3.highlight": "Compliance",
  "co.hero.slide3.subtitle": "Complete support to achieve and maintain international certifications, data protection law compliance and sector-specific regulatory compliance.",
  "co.hero.slide3.cta": "View certifications",

  "co.hero.backHome": "Back to Home",

  // Features
  "co.features.tag": "Services",
  "co.features.title": "Consulting",
  "co.features.highlight": "Capabilities",
  "co.features.subtitle": "Professional consulting services with international methodologies and a team of certified specialists",

  "co.features.f1.title": "Security Consulting",
  "co.features.f1.desc": "Specialized advisory to strengthen your security posture with proven methodologies and industry best practices. Comprehensive assessment of your current environment.",
  "co.features.f1.stat": "ISO 27001",
  "co.features.f1.statLabel": "Certification",

  "co.features.f2.title": "Technology Assessment",
  "co.features.f2.desc": "Comprehensive diagnostics of infrastructure, networks and security. Identification of vulnerabilities, compliance gaps and prioritized recommendations with roadmaps.",
  "co.features.f2.stat": "200+",
  "co.features.f2.statLabel": "Assessments",

  "co.features.f3.title": "Regulatory Compliance",
  "co.features.f3.desc": "Alignment with regulatory frameworks such as ISO 27001, PCI DSS, NIST and data protection laws. Support in audits and certifications.",
  "co.features.f3.stat": "15+",
  "co.features.f3.statLabel": "Frameworks",

  "co.features.f4.title": "Risk Management",
  "co.features.f4.desc": "Identification, analysis and treatment of information security risks with quantitative and qualitative methodologies aligned to ISO 31000 and ISO 27005.",
  "co.features.f4.stat": "500+",
  "co.features.f4.statLabel": "Risks mitigated",

  "co.features.f5.title": "Business Continuity",
  "co.features.f5.desc": "BCP and DRP development with business impact analysis (BIA), recovery strategies and periodic testing to ensure operational continuity in any scenario.",
  "co.features.f5.stat": "RTO < 4h",
  "co.features.f5.statLabel": "Guaranteed",

  "co.features.f6.title": "ISMS Implementation",
  "co.features.f6.desc": "Design and implementation of Information Security Management Systems with policies, procedures and controls aligned to your organization's strategic objectives.",
  "co.features.f6.stat": "50+",
  "co.features.f6.statLabel": "ISMS implemented",

  // CTA
  "co.cta.tag": "Start Consulting",
  "co.cta.title": "Boost your security with",
  "co.cta.subtitle": "A team of certified consultants with experience across multiple industries ready to transform your organization's security",
  "co.cta.button": "Request free advisory",
  "co.cta.homeButton": "View main site",
};